import { Asset, AssetFragment } from '@graphcommerce/graphcms-ui'
import { BlogHeader as NextBlogHeader } from '@graphcommerce/next-ui'

export function BlogHeader(props: { asset?: AssetFragment }) {
  const { asset } = props
  return <NextBlogHeader asset={asset ? <Asset asset={asset} className='!w-auto' /> : null} />
}
